"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRelay = void 0;
var component_1 = require("./component");
Object.defineProperty(exports, "withRelay", { enumerable: true, get: function () { return component_1.withRelay; } });
